import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import React, { useCallback } from 'react';

interface IJITDisabledFieldProps {
	value: boolean;
	onChange: (value: boolean) => void;
	disabled?: boolean;
	label?: string;
	name?: string;
}

const JITDisabledField: React.FC<IJITDisabledFieldProps> = ({
	value,
	onChange,
	disabled = false,
	label = intl.tr('common.fields.jit.label'),
	name = 'jit-disabled-field'
}) => {
	const handleChange = useCallback(
		(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
			onChange(checked);
		},
		[onChange]
	);

	return (
		<FormControlLabel
			name={name}
			disabled={disabled}
			label={<Typography variant="body1">{label}</Typography>}
			control={
				<Checkbox data-testid={name} checked={value} onChange={handleChange} />
			}
		/>
	);
};

export default JITDisabledField;
